export const sizing = {
  tableRowHeight: 43,
};
